var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyrightsHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_644_10900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C4.03749 18 0 13.9625 0 9C0 4.03749 4.03749 0 9 0C13.9625 0 18 4.03749 18 9C18 13.9625 13.9625 18 9 18ZM9 1.12501C4.65765 1.12501 1.12501 4.65765 1.12501 9C1.12501 13.3424 4.65765 16.875 9 16.875C13.3424 16.875 16.875 13.3424 16.875 9C16.875 4.65765 13.3424 1.12501 9 1.12501Z",
    fill: "#AE8FD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 13.5C6.51876 13.5 4.5 11.4813 4.5 9.00002C4.5 6.51872 6.51872 4.5 9.00002 4.5C10.22 4.5 11.3615 4.98011 12.2152 5.85187L11.411 6.63847C10.7711 5.98477 9.91522 5.62496 9.00002 5.62496C7.13893 5.62496 5.62501 7.13889 5.62501 8.99998C5.62501 10.8611 7.13893 12.375 9.00002 12.375C9.91465 12.375 10.7705 12.0152 11.411 11.3615L12.2141 12.1492C11.361 13.0205 10.2195 13.5 9.00002 13.5Z",
    fill: "#AE8FD6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_644_10900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyrightsHome);
export default __webpack_public_path__ + "static/media/Copyrights-home.64bb88a85c9aed5ab745b96bd6a847f5.svg";
export { ForwardRef as ReactComponent };